import type { ConfigPayload, ConfigResponse } from '@/types/apps/config.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';
import type { Deletable } from '@/types/service/deletable.interface';
import type { Indexable } from '@/types/service/indexable.interface';
import type { Showable } from '@/types/service/showable.interface';
import type { Updatable } from '@/types/service/updatable.interface';

export interface ConfigServiceInterface {}

type ConfigListResponse = ApiResponse<PaginatedResult<ConfigResponse>>;

export class ConfigService
    implements Showable, Updatable, Deletable, Creatable, Indexable
{
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/config',
        detail: (id: string) => `/api/config/${id}`,
    };

    public index(params?: QueryParams): Promise<ConfigListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }

    public update(
        id: string,
        payload: ConfigPayload
    ): Promise<ApiResponse<ConfigResponse>> {
        return this.apiClient.putApi(this.endpoints.detail(id), payload);
    }
}
